[
  {
    "code": "GR-I",
    "name": "Attica"
  },
  {
    "code": "GR-H",
    "name": "Central Greece"
  },
  {
    "code": "GR-B",
    "name": "Central Macedonia"
  },
  {
    "code": "GR-M",
    "name": "Crete"
  },
  {
    "code": "GR-A",
    "name": "Eastern Macedonia and Thrace"
  },
  {
    "code": "GR-D",
    "name": "Epirus"
  },
  {
    "code": "GR-F",
    "name": "Ionian Islands"
  },
  {
    "code": "GR-69",
    "name": "Mount Athos Autonomous Region"
  },
  {
    "code": "GR-K",
    "name": "Northern Aegean"
  },
  {
    "code": "GR-J",
    "name": "Peloponnese"
  },
  {
    "code": "GR-L",
    "name": "Southern Aegean"
  },
  {
    "code": "GR-E",
    "name": "Thessaly"
  },
  {
    "code": "GR-G",
    "name": "Western Greece"
  },
  {
    "code": "GR-C",
    "name": "Western Macedonia"
  }
]